"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  AL: "The Yellowhammer State",
  AK: "The Last Frontier",
  AZ: "The Grand Canyon State",
  AR: "The Natural State",
  CA: "The Golden State",
  CO: "The Centennial State",
  CT: "The Constitution State",
  DE: "The First State",
  FL: "The Sunshine State",
  FA: "The Peach State",
  HI: "The Aloha State",
  ID: "The Gem State",
  IL: "The Prairie State",
  IN: "The Hoosier State",
  IA: "The Hawkeye State",
  KS: "The Sunflower State",
  KY: "The Bluegrass State",
  LA: "The Pelican State",
  ME: "The Pine Tree State",
  MD: "The Old Line State",
  MA: "The Bay State",
  MI: "The Great Lakes State",
  MN: "The North Star State",
  MS: "The Magnolia State",
  MO: "The Show Me State",
  MT: "The Treasure State",
  NE: "The Cornhusker State",
  NV: "The Silver State",
  NH: "The Granite State",
  NJ: "The Garden State",
  NM: "The Land of Enchantment",
  NY: "The Empire State",
  NC: "The Tar Heel State",
  ND: "The Peace Garden State",
  OH: "The Buckeye State",
  OK: "The Sooner State",
  OR: "The Beaver State",
  PA: "The Keystone State",
  RI: "The Ocean State",
  SC: "The Palmetto State",
  SD: "The Mount Rushmore State",
  TN: "The Volunteer State",
  TX: "The Lone Star State",
  UT: "The Beehive State",
  VT: "The Green Mountain State",
  VA: "The Old Dominion State",
  WA: "The Evergreen State",
  WV: "The Mountain State",
  WI: "The Badger State",
  WY: "The Cowboy State",
  DC: "The Nation's Capital"
};